import { tv } from 'tailwind-variants';

export const imageGridVariants = tv({
  slots: {
    section: 'porta-container px-md py-md md:px-full-banner',
    grid: 'flex gap-4 md:gap-lg justify-between',
    imageWrapper: 'group relative overflow-hidden',
  },
  variants: {
    hasLink: {
      true: { imageWrapper: 'cursor-pointer transition-transform block' },
      false: {},
    },
    count: {
      single: {
        grid: 'justify-center',
        imageWrapper: 'w-full md:w-242.5',
      },
      multiple: {
        grid: 'flex-wrap',
        imageWrapper: 'w-full md:w-[calc(50%-16px)]',
      },
    },
  },
  defaultVariants: {
    hasLink: false,
    count: 'multiple',
  },
});
